import { render } from "./EditWasteCar.vue?vue&type=template&id=259d2151&scoped=true"
import script from "./EditWasteCar.vue?vue&type=script&lang=js"
export * from "./EditWasteCar.vue?vue&type=script&lang=js"

import "./EditWasteCar.vue?vue&type=style&index=0&id=259d2151&scoped=true&lang=css"

import exportComponent from "/home/le01s/WebstormProjects/am_logger_front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-259d2151"]])

export default __exports__